import React, { useContext, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { userImage } from '../icons';
import LogIn from './logIn';
import LogOut from './logOut';
import './navbarV2.css';
import { AuthContext } from '../../../provider/AuthContext';

type NavbarDesktopProps = {
  id: string;
  data: string;
  redirectLink: () => string;
};

const NavbarDesktop: React.FC<NavbarDesktopProps> = ({
  id,
  data,
  redirectLink,
}) => {
  // eslint-disable-next-line no-undef
  const token: string | null = localStorage.getItem('token');
  const checkLog: JSX.Element = !token ? <LogIn /> : <LogOut />;
  const { authState } = useContext(AuthContext);
  const userType: string = authState.user_type;

  const [imgdata, SetImgData] = useState<string>(
    _.get(data, 'profilePic.url', '')
  );

  useEffect(() => {
    if (!token) {
      SetImgData('');
    }
  }, [token]);
  // eslint-disable-next-line no-nested-ternary
  const navLinks =
    userType === 'admin' ? (
      <>
        <Dropdown.Item>
          <Link
            to="/user/profile"
            style={{
              textDecoration: 'none',
              color: '#000',
              display: 'block',
              width: '100%',
              padding: '5px',
            }}
          >
            My Bookings
          </Link>
        </Dropdown.Item>
        <Dropdown.Item>
          <Link
            to="/dashboardV2"
            style={{
              textDecoration: 'none',
              color: '#000',
              display: 'block',
              width: '100%',
              padding: '5px',
            }}
          >
            My Dashboard
          </Link>
        </Dropdown.Item>
        <Dropdown.Item>
          <Link
            to={`/mentor/${id}`}
            style={{
              textDecoration: 'none',
              color: '#000',
              display: 'block',
              width: '100%',
              padding: '5px',
            }}
          >
            My Mentor Profile
          </Link>
        </Dropdown.Item>
      </>
    ) : userType === 'mentor' ? (
      <>
        <Dropdown.Item>
          <Link
            to="/dashboardV2"
            style={{
              textDecoration: 'none',
              color: '#000',
              display: 'block',
              width: '100%',
              padding: '5px',
            }}
          >
            My Dashboard
          </Link>
        </Dropdown.Item>
        <Dropdown.Item>
          <Link
            to="/user/profile"
            style={{
              textDecoration: 'none',
              color: '#000',
              display: 'block',
              width: '100%',
              padding: '5px',
            }}
          >
            My Bookings
          </Link>
        </Dropdown.Item>
        <Dropdown.Item>
          <Link
            to="/searchMentor"
            style={{
              textDecoration: 'none',
              color: '#000',
              display: 'block',
              width: '100%',
              padding: '5px',
            }}
          >
            Find a Mentor
          </Link>
        </Dropdown.Item>
      </>
    ) : (
      <>
        <Dropdown.Item>
          <Link
            to="/searchMentor"
            style={{
              textDecoration: 'none',
              color: '#000',
              display: 'block',
              width: '100%',
              padding: '5px',
            }}
          >
            Find a Mentor
          </Link>
        </Dropdown.Item>
        <Dropdown.Item>
          <Link
            to="/user/profile"
            style={{
              textDecoration: 'none',
              color: '#000',
              display: 'block',
              width: '100%',
              padding: '5px',
            }}
          >
            My Bookings
          </Link>
        </Dropdown.Item>
      </>
    );
  return (
    <div className="navbar__desktop--container">
      <div className="navbar__desktop--logo">
        <Link to={redirectLink}>
          <svg
            width="139"
            height="23"
            viewBox="0 0 139 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.346 15.624L0.422 11.592L4.346 7.56H7.514L3.59 11.592L7.514 15.624H4.346ZM17.2697 7.884C18.0257 7.884 18.6977 8.052 19.2857 8.388C19.8737 8.712 20.3297 9.198 20.6537 9.846C20.9897 10.482 21.1577 11.25 21.1577 12.15V18H18.6377V12.492C18.6377 11.7 18.4397 11.094 18.0437 10.674C17.6477 10.242 17.1077 10.026 16.4237 10.026C15.7277 10.026 15.1757 10.242 14.7677 10.674C14.3717 11.094 14.1737 11.7 14.1737 12.492V18H11.6537V4.68H14.1737V9.27C14.4977 8.838 14.9297 8.502 15.4697 8.262C16.0097 8.01 16.6097 7.884 17.2697 7.884ZM33.9941 8.028L27.8201 22.716H25.1381L27.2981 17.748L23.3021 8.028H26.1281L28.7021 14.994L31.3121 8.028H33.9941ZM38.7725 9.468C39.0965 9.012 39.5405 8.634 40.1045 8.334C40.6805 8.022 41.3345 7.866 42.0665 7.866C42.9185 7.866 43.6865 8.076 44.3705 8.496C45.0665 8.916 45.6125 9.516 46.0085 10.296C46.4165 11.064 46.6205 11.958 46.6205 12.978C46.6205 13.998 46.4165 14.904 46.0085 15.696C45.6125 16.476 45.0665 17.082 44.3705 17.514C43.6865 17.946 42.9185 18.162 42.0665 18.162C41.3345 18.162 40.6865 18.012 40.1225 17.712C39.5705 17.412 39.1205 17.034 38.7725 16.578V22.752H36.2525V8.028H38.7725V9.468ZM44.0465 12.978C44.0465 12.378 43.9205 11.862 43.6685 11.43C43.4285 10.986 43.1045 10.65 42.6965 10.422C42.3005 10.194 41.8685 10.08 41.4005 10.08C40.9445 10.08 40.5125 10.2 40.1045 10.44C39.7085 10.668 39.3845 11.004 39.1325 11.448C38.8925 11.892 38.7725 12.414 38.7725 13.014C38.7725 13.614 38.8925 14.136 39.1325 14.58C39.3845 15.024 39.7085 15.366 40.1045 15.606C40.5125 15.834 40.9445 15.948 41.4005 15.948C41.8685 15.948 42.3005 15.828 42.6965 15.588C43.1045 15.348 43.4285 15.006 43.6685 14.562C43.9205 14.118 44.0465 13.59 44.0465 12.978ZM58.6218 12.798C58.6218 13.158 58.5978 13.482 58.5498 13.77H51.2598C51.3198 14.49 51.5718 15.054 52.0158 15.462C52.4598 15.87 53.0058 16.074 53.6538 16.074C54.5898 16.074 55.2558 15.672 55.6518 14.868H58.3698C58.0818 15.828 57.5298 16.62 56.7138 17.244C55.8978 17.856 54.8958 18.162 53.7078 18.162C52.7478 18.162 51.8838 17.952 51.1158 17.532C50.3598 17.1 49.7658 16.494 49.3338 15.714C48.9138 14.934 48.7038 14.034 48.7038 13.014C48.7038 11.982 48.9138 11.076 49.3338 10.296C49.7538 9.516 50.3418 8.916 51.0978 8.496C51.8538 8.076 52.7238 7.866 53.7078 7.866C54.6558 7.866 55.5018 8.07 56.2458 8.478C57.0018 8.886 57.5838 9.468 57.9918 10.224C58.4118 10.968 58.6218 11.826 58.6218 12.798ZM56.0118 12.078C55.9998 11.43 55.7658 10.914 55.3098 10.53C54.8538 10.134 54.2958 9.936 53.6358 9.936C53.0118 9.936 52.4838 10.128 52.0518 10.512C51.6318 10.884 51.3738 11.406 51.2778 12.078H56.0118ZM63.8811 9.576C64.2051 9.048 64.6251 8.634 65.1411 8.334C65.6691 8.034 66.2691 7.884 66.9411 7.884V10.53H66.2751C65.4831 10.53 64.8831 10.716 64.4751 11.088C64.0791 11.46 63.8811 12.108 63.8811 13.032V18H61.3611V8.028H63.8811V9.576ZM128.285 0.954L123.425 21.258H120.959L125.819 0.954H128.285ZM131.548 7.56H134.734L138.658 11.592L134.734 15.624H131.548L135.49 11.592L131.548 7.56Z"
              fill="#FD8E4A"
            />
            <path
              d="M72.0585 4.68V18H69.5385V4.68H72.0585ZM84.7183 12.798C84.7183 13.158 84.6943 13.482 84.6463 13.77H77.3563C77.4163 14.49 77.6683 15.054 78.1123 15.462C78.5563 15.87 79.1023 16.074 79.7503 16.074C80.6863 16.074 81.3523 15.672 81.7483 14.868H84.4663C84.1783 15.828 83.6263 16.62 82.8103 17.244C81.9943 17.856 80.9923 18.162 79.8043 18.162C78.8443 18.162 77.9803 17.952 77.2123 17.532C76.4563 17.1 75.8623 16.494 75.4303 15.714C75.0103 14.934 74.8003 14.034 74.8003 13.014C74.8003 11.982 75.0103 11.076 75.4303 10.296C75.8503 9.516 76.4383 8.916 77.1943 8.496C77.9503 8.076 78.8203 7.866 79.8043 7.866C80.7523 7.866 81.5983 8.07 82.3423 8.478C83.0983 8.886 83.6803 9.468 84.0883 10.224C84.5083 10.968 84.7183 11.826 84.7183 12.798ZM82.1083 12.078C82.0963 11.43 81.8623 10.914 81.4063 10.53C80.9503 10.134 80.3923 9.936 79.7323 9.936C79.1083 9.936 78.5803 10.128 78.1483 10.512C77.7283 10.884 77.4703 11.406 77.3743 12.078H82.1083ZM86.8096 12.978C86.8096 11.97 87.0076 11.076 87.4036 10.296C87.8116 9.516 88.3576 8.916 89.0416 8.496C89.7376 8.076 90.5116 7.866 91.3636 7.866C92.1076 7.866 92.7556 8.016 93.3076 8.316C93.8716 8.616 94.3216 8.994 94.6576 9.45V8.028H97.1956V18H94.6576V16.542C94.3336 17.01 93.8836 17.4 93.3076 17.712C92.7436 18.012 92.0896 18.162 91.3456 18.162C90.5056 18.162 89.7376 17.946 89.0416 17.514C88.3576 17.082 87.8116 16.476 87.4036 15.696C87.0076 14.904 86.8096 13.998 86.8096 12.978ZM94.6576 13.014C94.6576 12.402 94.5376 11.88 94.2976 11.448C94.0576 11.004 93.7336 10.668 93.3256 10.44C92.9176 10.2 92.4796 10.08 92.0116 10.08C91.5436 10.08 91.1116 10.194 90.7156 10.422C90.3196 10.65 89.9956 10.986 89.7436 11.43C89.5036 11.862 89.3836 12.378 89.3836 12.978C89.3836 13.578 89.5036 14.106 89.7436 14.562C89.9956 15.006 90.3196 15.348 90.7156 15.588C91.1236 15.828 91.5556 15.948 92.0116 15.948C92.4796 15.948 92.9176 15.834 93.3256 15.606C93.7336 15.366 94.0576 15.03 94.2976 14.598C94.5376 14.154 94.6576 13.626 94.6576 13.014ZM103.077 9.576C103.401 9.048 103.821 8.634 104.337 8.334C104.865 8.034 105.465 7.884 106.137 7.884V10.53H105.471C104.679 10.53 104.079 10.716 103.671 11.088C103.275 11.46 103.077 12.108 103.077 13.032V18H100.557V8.028H103.077V9.576ZM114.26 7.884C115.448 7.884 116.408 8.262 117.14 9.018C117.872 9.762 118.238 10.806 118.238 12.15V18H115.718V12.492C115.718 11.7 115.52 11.094 115.124 10.674C114.728 10.242 114.188 10.026 113.504 10.026C112.808 10.026 112.256 10.242 111.848 10.674C111.452 11.094 111.254 11.7 111.254 12.492V18H108.734V8.028H111.254V9.27C111.59 8.838 112.016 8.502 112.532 8.262C113.06 8.01 113.636 7.884 114.26 7.884Z"
              fill="#8C52FF"
            />
          </svg>
        </Link>
      </div>
      <div className="navbar__desktop--user-box">
        <Dropdown>
          <Dropdown.Toggle variant="" id="dropdown-basic">
            {imgdata ? (
              <img
                src={imgdata}
                alt="..."
                style={{
                  height: '25px',
                  width: '25px',
                  borderRadius: '50%',
                  border: '0.5 solid #000',
                }}
              />
            ) : (
              <img
                src={userImage}
                alt="..."
                style={{ height: '25px', width: '25px' }}
              />
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {navLinks}
            <Dropdown.Item>{checkLog}</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default NavbarDesktop;
